import { CommonModule } from '@angular/common'
import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  Output,
  EventEmitter,
  CUSTOM_ELEMENTS_SCHEMA,
} from '@angular/core'

@Component({
  selector: 'accordion',
  standalone: true,
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './accordion.component.html',
  styleUrl: './accordion.component.scss',
})
export class AccordionComponent {
  constructor() {}

  @Input() title: string = ''
  @Output() active = new EventEmitter<any>()
  isActive: Boolean = false
  iconName = 'chevrondownmedium'
  toggle() {
    this.isActive = !this.isActive
    this.active.emit(this.isActive)
    this.iconName = this.isActive ? 'chevronupmedium' : 'chevrondownmedium'
  }
}
